import React from "react";
import TemplateEditor from "./TemplateEditor";

export default function TemplateEditorModal({
  open,
  onClose,
  templates,
  tplLoading,
  tplErr,
  onRefresh,
  onSaved,
  sampleRow,
}) {
  if (!open) return null;
  return (
    <div className="psl-modal-overlay" role="dialog" aria-modal="true" aria-label="Template Editor">
      <div className="psl-modal" style={{ maxWidth: 920, width: "96vw", maxHeight: "90vh", overflow: "auto" }}>
        <div className="psl-modal-top">
          <h3>Template Editor</h3>
          <button className="psl-btn" onClick={onClose}>Close</button>
        </div>
        <TemplateEditor
          templates={templates}
          tplLoading={tplLoading}
          tplErr={tplErr}
          onRefresh={onRefresh}
          onSaved={onSaved}
          sampleRow={sampleRow}
        />
      </div>
    </div>
  );
}